import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// layouts
import MainLayout from 'src/layouts/main';
// components
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/legalizaciones'));
// const IniciarNuevaSolicitud = lazy(() => import('src/pages/legalizaciones/foundation/typography'));

// ----------------------------------------------------------------------

export const legalizacionesRoutes = [
  {
    element: (
      <MainLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </MainLayout>
    ),

    path: 'legalizaciones',
    children: [{ element: <IndexPage />, index: true }],
  },
];
